import React, { useState, useContext } from "react";
import { NavigationContext } from "navigation-react";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import LoaderAnimation from "./LoaderAnimationLarge";

const DeleteCTScanReportRegister = () => {
  const { data, stateNavigator } = useContext(NavigationContext);
  const [loading, setLoading] = useState(false);

  console.log("data?.ctscan_report_nid", data?.ctscan_report_nid);

  if (loading) {
    return <LoaderAnimation loadingTxt="Deleting report..." />;
  }

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `/node/${data?.ctscan_report_nid}?_format=json`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Basic ${btoa("salisu:abc@123@Q")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        setLoading(false);
        stateNavigator.navigate("ctscanreportregister");
        alert("Report deleted successfully!");
      } else {
        setLoading(false);
        const error = await response.json();
        alert(`Error: ${JSON.stringify(error.message)}`);
        console.log("Error:", error);
      }
    } catch (error) {
      setLoading(false);
      alert(`Error:", ${error.message}`);
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="delete-patient-register">
          <div className="deleteBlock">
            <div className="deleteNcancleTxt">
              <p>Are you sure you want to delete</p>
              <span>{`${data?.ctscan_report_patient_name}`} ?</span>
            </div>
            <div className="deleteNcancleAction">
              <button onClick={() => handleDelete()}>Yes</button>
              <button
                onClick={() => stateNavigator.navigate("ctscanreportregister")}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default DeleteCTScanReportRegister;
